import script from "./MonitoringDispatcherView.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringDispatcherView.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringDispatcherView.vue?vue&type=style&index=0&id=f9da7438&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9da7438"]])

export default __exports__